import { gql } from '@apollo/client'

export const GET_CAMPAIGNS_FOR_PICKER = gql`
    query CampaignsForPicker {
        campaigns {
            id
            name
            hasSubscriptions
            systemStatus
        }
    }
`
